import React, {Fragment} from 'react';
import {Button, Stack, Typography} from '@mui/material';

import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';

import contractImg from 'presentation/assets/images/contract-now@2x.webp';
import {useHostName} from 'presentation/hooks';
import {SalesLinkEnum} from 'presentation/constants';
import {LoginEnum} from 'main/analytics/gaTagsEnum';
import {StyledCard, StyledTypography} from './styles';

const {title, description, action} = translations['pt-br'].publicFlow.signIn.newContract;

export function ContractNow() {
	const {
		dataHostNameState: {product},
	} = useHostName();
	const salesUrl = SalesLinkEnum[product];

	return (
		<Fragment>
			<StyledCard>
				<Stack gap={2}>
					<Stack flexDirection="row" alignItems="center" justifyContent="space-between">
						<StyledTypography>{title}</StyledTypography>
						<img src={contractImg} width={140} height={90} alt="Contrate online" />
					</Stack>
					<Typography variant="body2">{description}</Typography>
					<Button
						variant="outlined"
						size="large"
						href={salesUrl}
						target="_blank"
						rel="noopener noreferrer"
						endIcon={<Icon name="arrow-right-filled" />}
						data-tag-id={LoginEnum.CLICK_SIMULE_SEU_PLANO}>
						{action}
					</Button>
				</Stack>
			</StyledCard>
		</Fragment>
	);
}
